import { Component, OnInit } from '@angular/core';
import { ASSETS_PATH } from 'src/app/core/config';
import { AlertService } from 'src/app/core/services/alert.service';
import { EventService } from 'src/app/core/services/event.service';
import { LoadingService } from 'src/app/core/services/loading.service';

@Component({
  selector: 'app-my-events',
  templateUrl: './my-events.component.html',
  styleUrls: ['./my-events.component.scss']
})
export class MyEventsComponent implements OnInit {
  events = [];
  assetsPath = ASSETS_PATH; 

  constructor(private alertService: AlertService,
    private loadingService: LoadingService,
    private eventService: EventService) { }

  ngOnInit(): void {
    this.getEventList();
  }

  getEventList(){
    this.loadingService.setLoading(true);
    this.eventService.getMyEvents().subscribe(response => {
      if (response.success) {
        this.events = response.events;
        this.loadingService.setLoading(false);
      }
    },
    (error) => {
      this.loadingService.setLoading(false);
      this.alertService.alert('Hata!', error.error.Message, 'error');
    });
  }
}
